module.exports = __webpack_public_path__ + "static/media/hd_check.e8fad9ba.png";